import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';
import { ReportDialogs } from '../../constants/Dialogs';

import AddEntityActionButton from '../Common/AddEntityActionButton';
import TableView from '../Common/TableView';
import ReportScheduleTableRow from './ReportScheduleTableRow';
import ReportScheduleDialog from './ReportScheduleDialog';

import DialogActions from '../../actions/DialogActionCreator';
import ReportActions from '../../actions/ReportActionCreator';
import ReportScheduleStore from '../../stores/ReportScheduleStore';

import { withId } from '../Common/Decorators';

const formatSchedule = (schedule) => {
    if (!schedule) { return null; }
    if (schedule instanceof Date) { return schedule; }

    const time = schedule.split(':');
    const date = new Date();
    date.setHours(time[0], time[1]);

    return date;
}

class ReportSchedules extends Component {

    componentDidMount() {
        ReportActions.listSchedules();
    }

    render() {
        return (
            <TableView
                title="Scheduled reports"
                headers={['Name', 'Report', 'Time', 'Repeat Interval', 'Created', 'Recipients', '']}
                rows={this.state.schedules}
                decorator={ReportScheduleTableRow}
                backButton={true}
                isFetching={this.state.isFetching}
                itemActions={{
                    onEdit: (row) => DialogActions.open(ReportDialogs.SCHEDULE_EDIT, {...row, schedule: formatSchedule(row.schedule)}),
                    onDelete: (scheduleId) => ReportActions.deleteSchedule(scheduleId)
                }}
            >
                <AddEntityActionButton onClick={() => DialogActions.open(ReportDialogs.SCHEDULE_ADD)} />
                <ReportScheduleDialog/>
            </TableView>
        );
    }
}

ReportSchedules.getStores = () => [ReportScheduleStore];
ReportSchedules.calculateState = (prevState) => ({
    schedules: ReportScheduleStore.getAll(),
    isFetching: ReportScheduleStore.isFetching()
});
ReportSchedules.contextTypes = {
    auth: PropTypes.object.isRequired
}

export default withId(Container.create(ReportSchedules, { withProps: true }));
